import { useEffect, useState } from 'react';

import { faCheck, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';
import classNames from 'classnames';

type HistoricalAnalysisStatusProps = {
  isAnalyzing: boolean;
  isComplete: boolean;
};

export const HistoricalAnalysisStatus = ({
  isAnalyzing,
  isComplete,
}: HistoricalAnalysisStatusProps) => {
  const [showComplete, setShowComplete] = useState(false);

  useEffect(() => {
    if (isComplete) {
      setShowComplete(true);
      // Hide after 3 seconds
      const timer = setTimeout(() => {
        setShowComplete(false);
      }, 3000);
      return () => clearTimeout(timer);
    } else if (isAnalyzing) {
      setShowComplete(false);
    }
  }, [isAnalyzing, isComplete]);

  if (!isAnalyzing && !showComplete) {
    return null;
  }

  return (
    <div className="vai-flex vai-items-center vai-justify-center vai-gap-2 vai-mb-3">
      <FontAwesomeIcon
        icon={showComplete ? faCheck : faSpinner}
        className={classNames('vai-h-3 vai-w-3 vai-text-zinc-300', {
          'vai-animate-spin': !showComplete,
        })}
      />
      <span className="vai-text-[12px] vai-text-zinc-300">
        {showComplete ? (
          <Trans>Historical analysis complete.</Trans>
        ) : (
          <Trans>Analyzing historical images for aligner recommendation.</Trans>
        )}
      </span>
    </div>
  );
};
